import { CollectionReference, collection, doc, getDoc, getDocs, query, where } from 'firebase/firestore';
import { db } from '~/config/firebase.config';
import { GameConverter } from './game.converter';
import { Game } from '../game.class';

/** Firestore Query that select games from a list of ids */
function containsIdSelector(col: CollectionReference, ids: string[]) {
    return query(col, where('id', 'in', ids));
}

export class GameDatabase {
    /**
     * Get a game from the firestore database
     * @param gameID the game identifier
     * @returns the corresponding game classe
     */
    static async getGame(gameID: string) {
        return GameDatabase._getGameByID(gameID);
    }

    /**
     * Get games data from the firestore database
     * If '*' is used as an argument, then the function returns the full list of games.
     * @param gameIDs '*' or a list of game ids
     * @returns the corresponding game classes
     */
    static async getGames(gameIDs: string | Array<string> = '*') {
        let res: Promise<Game[]>;
        if (gameIDs instanceof Array) {
            if (gameIDs.length > 0) {
                res = GameDatabase._getGames((col) => containsIdSelector(col, gameIDs));
            } else {
                res = new Promise<Game[]>(() => {});
            }
        } else if (gameIDs === '*') {
            res = GameDatabase._getGames((col) => col);
        } else {
            throw new Error('Argument error.');
        }
        return res;
    }

    private static async _getGames(selector: (col: CollectionReference) => any) {
        const games: Array<Game> = [];
        const gameCollection = collection(db, 'games').withConverter(GameConverter);
        const querySelector = selector(gameCollection);
        const snapshots = await getDocs(querySelector);

        snapshots.forEach((snap: any) => {
            games.push(snap.data());
        });

        return games;
    }

    private static async _getGameByID(gameID: string) {
        const gameRef = doc(db, 'games', gameID).withConverter(GameConverter);
        const game = await getDoc(gameRef)
            .then((snap) => {
                if (snap.exists()) {
                    return snap.data();
                }
                throw new Error(`Game '${gameID}' does not exist.`);
            })
            .catch((err) => {
                throw new Error(`Cannot get game document with ref '/games/${gameID}'\n[code=${err.code}]`);
            });
        return game;
    }
}
